import { CADStyle, LineType } from '@technology/web3d-plugin-line-editing';
import { DrawingTool } from '@trimble/geospatial';
import { UnreachableCaseError } from 'ts-essentials';

export const CAD_EDITING_MODEL_ID = 'cad-editing';
// Both the CAD metadata bag and features-service feature metadata carry the
// layer under this key, so the selection and ingest paths read the same name.
export const LAYER_ID_METADATA_KEY = 'common_layerId';
const POINT_SIZE = 10;
const LINE_WIDTH = 2;
export const POINT_STYLE_COLOR = '#ff6347';
export const LINE_STYLE_COLOR = 'blue';
export const POINT_DRAWING_STYLE = new CADStyle(
  POINT_STYLE_COLOR,
  LINE_WIDTH,
  LineType.Solid,
  POINT_SIZE
);
export const LINE_DRAWING_STYLE = new CADStyle(
  LINE_STYLE_COLOR,
  LINE_WIDTH,
  LineType.Solid
);

export function drawingStyleForTool(tool: DrawingTool): CADStyle {
  switch (tool) {
    case DrawingTool.Point:
      return POINT_DRAWING_STYLE;
    case DrawingTool.CompoundCurve:
    case DrawingTool.Rectangle:
    case DrawingTool.Polygon:
      return LINE_DRAWING_STYLE;
    default:
      throw new UnreachableCaseError(tool);
  }
}
